import React, { useState } from 'react'
import MyButton from '../../../../../../UI/form/MyButton'
import ChecklistIcon from '@mui/icons-material/Checklist';
import MyModal from '../../../../../../UI/modal/MyModal';
import AgreeDirectorForm from './AgreeDirectorForm';

const AgreeDirectorButton = ({ supplyOrderId, checked, setChecked }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <ChecklistIcon />
            <span>Погодити</span>
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={'Погодження позицій'}
            disableClickOutside={true}
            content={
                <AgreeDirectorForm
                    // supplyOrderBd={supplyOrder}
                    supplyOrderId={supplyOrderId}
                    // supplyOrderItems={supplyOrderItems}
                    checked={checked}
                    setChecked={setChecked}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeDirectorButton